import { render, staticRenderFns } from "./attachModal.vue?vue&type=template&id=634d98c8"
import script from "./attachModal.vue?vue&type=script&lang=js"
export * from "./attachModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('634d98c8')) {
      api.createRecord('634d98c8', component.options)
    } else {
      api.reload('634d98c8', component.options)
    }
    module.hot.accept("./attachModal.vue?vue&type=template&id=634d98c8", function () {
      api.rerender('634d98c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GpsViews/Admin/Plants/Plant/Loads/attachModal.vue"
export default component.exports